import { useSignal } from "@preact/signals";
import { format } from "date-fns";
import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import SearchIcon from "@material-design-icons/svg/outlined/search.svg";
import { TextField } from "~/components";
import { getChats } from "~/core/store";
import { NavLink, Outlet } from "react-router-dom";
import cn from "classnames";

const Inbox: FC = () => {
    const search = useSignal("");
    const { chats, load, loading, popup } = getChats();

    useEffect(() => {
        load();
    }, [load]);

    useEffect(() => {
        const isPopup = popup.peek();

        popup.value = false;

        return () => {
            popup.value = isPopup;
        };
    }, [popup]);

    return (
        <div>
            <div className="flex px-4 py-2 border-b border-gray-200">
                <TextField
                    placeholder="Search..."
                    value={search.value}
                    onInput={({ currentTarget }) =>
                        (search.value = currentTarget.value)
                    }
                    leftIcon={
                        <SearchIcon
                            width="18"
                            height="18"
                            className="fill-current"
                        />
                    }
                />
            </div>
            <div className="flex w-full max-h-[calc(100vh-101px)] h-[calc(100vh-101px)] overflow-y-auto">
                <div className="w-[360px] min-w-[360px] h-full max-h-full overflow-y-auto border-r border-gray-200">
                    {chats.value.map((chat) => (
                        <NavLink
                            key={chat.id}
                            to={`/me/inbox/${chat.id}`}
                            className={({ isActive }: { isActive: boolean }) =>
                                cn(
                                    "flex items-center px-4 py-2 border-b border-gray-200",
                                    isActive
                                        ? "bg-sky-500 text-white"
                                        : "hover:bg-sky-50"
                                )
                            }
                        >
                            <div className="w-10 h-10 min-w-[40px] min-h-[40px] bg-gray-200 rounded-full">
                                <span />
                            </div>
                            <div className="w-full ml-2">
                                <div className="flex justify-between w-full">
                                    <div className="text-sm font-semibold">
                                        {chat.name}
                                    </div>
                                    <div className="text-xs font-bold">
                                        {chat.lastMessage &&
                                            format(
                                                new Date(
                                                    chat.lastMessage?.timestamp
                                                ),
                                                "dd MMM HH:mm"
                                            )}
                                    </div>
                                </div>
                                <div className="text-xs">
                                    {chat.lastMessage && (
                                        <>
                                            <span className="font-bold">
                                                {
                                                    chat.lastMessage.sender
                                                        .firstName
                                                }
                                                :{" "}
                                            </span>
                                            <span>
                                                {chat.lastMessage?.content}
                                            </span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </NavLink>
                    ))}
                </div>
                <div className="flex w-full">
                    {!loading.value && <Outlet />}
                </div>
            </div>
        </div>
    );
};

export default Inbox;
